import { Component, input } from '@angular/core';

@Component({
  selector: 'app-no-records',
  standalone: true,
  imports: [],
  templateUrl: './no-records.component.html',
  styleUrl: './no-records.component.scss'
})
export class NoRecordsComponent {
  minHeight = input<string>('200px');
}
